<template>
  <div class="inews">
    <div class="w">
      <div class="headx">
        <h2>
          <em>
            <b>新闻</b>资讯
          </em>
          <span></span>
        </h2>
        <a href="/news" class="mo">MORE+</a>
      </div>
      <div class="tod" id="inews">
        <ul class="list">
          <li v-for="(item, index) in newNews" :key="index" @click="toDetail(item)">
            <em>
              {{ item.month_day }}
              <b>{{ item.year }}</b>
            </em>
            <div class="wd">
              <a :href="'/news/news_detail?id=' + item.id + '&cate=' + item.cate" :title=" item.title">
                <h1>{{ item.title }}</h1>
              </a>
              <span>{{ item.description }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  data() {
    return {
      http: process.env.VUE_APP_BASE_API,
      newNews:[],
    };
  },
  mounted() {
    this.getNews();
  },
  methods: {
      async getNews() {
       const res = await method.index();
       if (res.code == 1) {
        this.newNews = res.data.news;
       }
      // console.log(this.newNews);
    },
    toDetail(item) {
      this.$router.push({
        path: '/news/news_detail',
        query: {
          id: item.id,
          cate: item.cate
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/pc/index_News.scss";
@import "@/assets/css/move/index_News.scss"
</style>